import { env } from "../config/env";
import { createClient } from "./http";
import { getAuthToken } from "../pages/AdminAuth/components/authStore";

const api = createClient(env.CATALOG_BASE_URL);

function authHeaders() {
  const token = getAuthToken?.() || "";
  return token ? { Authorization: `Bearer ${token}` } : {};
}
function pickArray(value) { return Array.isArray(value) ? value : []; }
function buildImageUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  const base = String(env.CATALOG_BASE_URL || "").replace(/\/+$/, "");
  const cleanPath = String(path).replace(/^\/+/, "");
  return base ? `${base}/${cleanPath}` : `/${cleanPath}`;
}
function normalizeVariant(item = {}, index = 0) {
  const name =
    item?.variantName ||
    item?.variant_name ||
    item?.name ||
    item?.label ||
    "";

  const unitValue =
    item?.unitValue ||
    item?.unit_value ||
    item?.weightValue ||
    item?.weight_value ||
    "";

  const unitSymbol =
    item?.unitSymbol ||
    item?.unit_symbol ||
    item?.weightUnitSymbol ||
    item?.weight_unit_symbol ||
    "";

  const prices = pickArray(item?.prices);
  const bestPrice = pickBestPrice(prices);

  const images = pickArray(item?.images).map((img) => {
    if (typeof img === "string") return { url: buildImageUrl(img) };

    return {
      ...img,
      url: buildImageUrl(img?.url || img?.image_url || img?.imageUrl || ""),
    };
  });

  return {
    ...item,
    id: item?.id || item?._id || "",
    variantName: name,
    name: name || [unitValue, unitSymbol].filter(Boolean).join(" ") || `Variant ${index + 1}`,
    label: item?.label || name || [unitValue, unitSymbol].filter(Boolean).join(" "),
    variantGroup: item?.variantGroup || item?.variant_group || "",
    variantValue: item?.variantValue || item?.variant_value || "",
    packLabel: item?.packLabel || item?.pack_label || "",
    variantSku: item?.variantSku || item?.variant_sku || item?.sku || "",
    barcode: item?.barcode || item?.variantBarcode || item?.variant_barcode || "",
    unitValue,
    unitSymbol,
    weightValue: item?.weightValue || item?.weight_value || "",
    weightUnitSymbol: item?.weightUnitSymbol || item?.weight_unit_symbol || "",
    shortDescription: item?.shortDescription || item?.short_description || "",
    description: item?.description || "",
    isDefault: Boolean(item?.isDefault ?? item?.is_default ?? index === 0),
    isActive: item?.isActive ?? item?.is_active ?? null,
    assigned: item?.assigned ?? null,
    prices,
    images,
    batches: pickArray(item?.batches),
    mrp: item?.mrp ?? bestPrice?.mrp ?? null,
    sellingPrice:
      item?.sellingPrice ??
      item?.selling_price ??
      bestPrice?.sellingPrice ??
      bestPrice?.selling_price ??
      null,
  };
}
function pickBestPrice(prices = []) {
  const list = pickArray(prices); if (!list.length) return {};
  const warehousePrices = list.filter((p) => p?.warehouseId);
  if (warehousePrices.length) return warehousePrices[warehousePrices.length - 1] || {};
  return list[list.length - 1] || {};
}
function normalizeProduct(item = {}) {
  const prices = pickArray(item?.prices);
  const images = pickArray(item?.images).map((img) => {
  if (typeof img === "string") return { url: buildImageUrl(img) };

  return {
    ...img,
    url: buildImageUrl(img?.url || img?.image_url || img?.imageUrl || ""),
  };
});
  const variantsSource = pickArray(item?.variants).length ? pickArray(item?.variants) : [{
    id: item?.defaultVariantId || "",
    variantName: item?.variantName || [item?.weightValue || item?.weight_value, item?.weightUnitSymbol || item?.weight_unit_symbol].filter(Boolean).join("") || "Default",
    weightValue: item?.weightValue || item?.weight_value || "",
    weightUnitSymbol: item?.weightUnitSymbol || item?.weight_unit_symbol || "",
    isDefault: true,
    mrp: item?.mrp ?? null,
    sellingPrice: item?.sellingPrice ?? item?.selling_price ?? null,
  }];
  const variants = variantsSource.map(normalizeVariant);
  const defaultVariant = variants.find((v) => v?.isDefault) || variants[0] || null;
  const warehousePrice = pickBestPrice(defaultVariant?.prices?.length ? defaultVariant.prices : prices);
  const primaryImage = images.find((img) => img?.isPrimary)?.url || images[0]?.url || item?.image_url || item?.imageUrl || "";
  return {
    ...item,
    id: item?.id || item?._id || "",
    name: item?.name || "",
    sku: item?.sku || "",
    barcode: item?.barcode || "",
    slug: item?.slug || "",
    short_description: item?.short_description || item?.shortDescription || "",
    description: item?.description || "",
    image_url: buildImageUrl(primaryImage),
    category_id: item?.category_id || item?.categoryId || item?.category?.id || "",
    categoryId: item?.categoryId || item?.category_id || item?.category?.id || "",
    category_parent_id: item?.category_parent_id || item?.categoryParentId || item?.category?.parentId || item?.category?.parent_id || "",
    categoryParentId: item?.categoryParentId || item?.category_parent_id || item?.category?.parentId || item?.category?.parent_id || "",
    category_name: item?.category_name || item?.categoryName || item?.category?.name || "",
    categoryName: item?.categoryName || item?.category_name || item?.category?.name || "",
    subcategory_id: item?.subcategory_id || item?.subCategoryId || item?.subcategoryId || item?.category_id || item?.categoryId || item?.category?.id || "",
    subCategoryId: item?.subCategoryId || item?.subcategory_id || item?.subcategoryId || item?.category_id || item?.categoryId || item?.category?.id || "",
    subcategoryId: item?.subcategoryId || item?.subcategory_id || item?.subCategoryId || item?.category_id || item?.categoryId || item?.category?.id || "",
    subcategory_name: item?.subcategory_name || item?.subCategoryName || item?.subcategoryName || item?.category_name || item?.categoryName || item?.category?.name || "",
    subCategoryName: item?.subCategoryName || item?.subcategory_name || item?.subcategoryName || item?.category_name || item?.categoryName || item?.category?.name || "",
    subcategoryName: item?.subcategoryName || item?.subcategory_name || item?.subCategoryName || item?.category_name || item?.categoryName || item?.category?.name || "",
    brand_id: item?.brand_id || item?.brandId || item?.brand?.id || "",
    brandId: item?.brandId || item?.brand_id || item?.brand?.id || "",
    brand_name: item?.brand_name || item?.brandName || item?.brand?.name || "",
    brandName: item?.brandName || item?.brand_name || item?.brand?.name || "",
    unit_name: item?.unit_name || item?.unitName || item?.unit?.name || "",
    unit_symbol: item?.unit_symbol || item?.unitSymbol || item?.unit?.symbol || "",
    tax_percent: item?.tax_percent || item?.taxPercent || "",
    weight_value: item?.weight_value || item?.weightValue || "",
    weight_unit_symbol: item?.weight_unit_symbol || item?.weightUnitSymbol || "",
    mrp: warehousePrice?.mrp ?? item?.mrp ?? "",
    selling_price: warehousePrice?.sellingPrice ?? warehousePrice?.selling_price ?? item?.selling_price ?? item?.sellingPrice ?? "",
    is_active: item?.is_active ?? item?.isActive ?? true,
    status: item?.status || "",
    prices,
    images,
    variants,
    defaultVariant,
    batches: pickArray(item?.batches),
  };
}
function extractListPayload(res) {
  const raw = res?.data ?? res ?? {};
  const items = raw?.items || raw?.data?.items || raw?.rows || raw?.products || raw?.data || [];
  const total = raw?.total || raw?.data?.total || raw?.count || raw?.pagination?.total || 0;
  const page = raw?.page || raw?.data?.page || raw?.pagination?.page || 1;
  const limit = raw?.limit || raw?.data?.limit || raw?.pagination?.limit || 20;
  return { items: pickArray(items).map(normalizeProduct), total: Number(total || 0), page: Number(page || 1), limit: Number(limit || 20) };
}
function extractSimpleList(res) {
  const raw = res?.data ?? res ?? {};
  const items = raw?.items || raw?.data || raw?.rows || [];
  return pickArray(items);
}

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => {
      if (value === undefined || value === null) return false;
      if (typeof value === "string" && value.trim() === "") return false;
      return true;
    }),
  );
}

export const warehouseCatalogService = {
  async listAssignedProducts({
    q = "",
    brandId = "",
    categoryId = "",
    subCategoryId = "",
    subcategoryId = "",
    page = 1,
    limit = 20,
  } = {}) {
    const finalSubcategoryId = subCategoryId || subcategoryId || "";

    const res = await api.get("/api/warehouse/catalog/products", {
      params: cleanParams({
        q,
        brandId,
        categoryId,
        subCategoryId: finalSubcategoryId,
        subcategoryId: finalSubcategoryId,
        page,
        limit,
      }),
      headers: authHeaders(),
    });

    return extractListPayload(res);
  },
  async getBrands() { const res = await api.get("/api/warehouse/catalog/brands", { headers: authHeaders() }); return extractSimpleList(res); },
  async getCategories() { const res = await api.get("/api/warehouse/catalog/categories", { headers: authHeaders() }); return extractSimpleList(res); },
  async getAllCategories() {
    try {
      const res = await api.get("/api/admin/categories/", { headers: authHeaders() });
      return extractSimpleList(res);
    } catch (err) {
      const res = await api.get("/api/warehouse/catalog/categories", { headers: authHeaders() });
      return extractSimpleList(res);
    }
  },
  async getSubcategories(params = {}) {
    const categoryId = params?.categoryId || params?.parentId || params?.parent_id || "";
    const safeParams = cleanParams({ ...params, categoryId });

    // Backend requires categoryId for this endpoint. Do not call it with an empty value;
    // otherwise the page shows "categoryId is required" before the user selects a category.
    if (!safeParams.categoryId) return [];

    const res = await api.get("/api/warehouse/catalog/subcategories", {
      params: safeParams,
      headers: authHeaders(),
    });

    return extractSimpleList(res);
  },
  async getProductById(id) {
    const res = await api.get(`/api/warehouse/catalog/products/${id}`, { headers: authHeaders() });
    const raw = res?.data ?? res ?? {};
    const item = raw?.item || raw?.data || raw;
    return normalizeProduct(item);
  },
};
